// 🔧 RequireEventId.js
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useEventContext } from "../hooks/use_event_context";

import { logger } from '../utils/logger';

const RequireEventId = ({ children }) => {
  const navigate = useNavigate();
  const { eventId, ready } = useEventContext();

  useEffect(() => {
    if (ready && !eventId) {
      logger.warn("🚫 Invalid eventSlug, redirecting to /404", {});
      navigate("/not-found?rei", { replace: true });
    }
  }, [ready, eventId, navigate]);

  return children;
};

export default RequireEventId;
